<template>
  <div class="testimonials-slider" :class="{'with-decoration-triangle': showDecorationTriangle}">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(testimonial, index) in testimonials" :key="index"
                    class="testimonials-slider__slide">
        <div class="testimonials-slider__slide-content">
          <blockquote v-html="testimonial.content"></blockquote>
          <p class="testimonials-slider__slide-author">
            <span v-if="testimonial.author">{{testimonial.author}}</span>
            <span v-if="testimonial.title">{{testimonial.title}}</span>
          </p>
        </div>
      </swiper-slide>
      <div class="testimonials-slider__button-prev swiper-button-prev" slot="button-prev">
        <icon-arrow-left class="arrow"></icon-arrow-left>
      </div>
      <div class="testimonials-slider__button-next swiper-button-next" slot="button-next">
        <icon-arrow-right class="arrow"></icon-arrow-right>
      </div>
      <div class="testimonials-slider__pagination swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import IconArrowLeft from "./IconArrowLeft.svg"
  import IconArrowRight from "./IconArrowRight.svg"

  export default {
    name: "TestimonialsSlider",
    components: {
      Swiper,
      SwiperSlide,
      IconArrowLeft,
      IconArrowRight
    },
    directives: { swiper: directive },
    props: {
      testimonials: { type: Array, default: () => [] },
      showDecorationTriangle: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        swiperOption: {
          grabCursor: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: '.testimonials-slider__pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
        }
      }
    }
  }
</script>

<style lang="scss">
  @import 'scss/swiper';

  $color-rwl-green-100: #a2d100;
  $color-rwl-green-500: #c7d673;

  .swiper-pagination {
    position: relative;
    padding-top: 25px;

    &-bullet {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: solid 2px $color-rwl-green-100;
      opacity: 1;
      margin: 0 15px;
      transition: background-color 300ms ease-in-out;

      &:hover {
        background-color: $color-rwl-green-50;
      }

      &.swiper-pagination-bullet-active {
        background-color: $color-rwl-green-100;
      }
    }
  }
</style>

<style scoped lang="scss">
  @import "scss/variables.scss";

  $arrow-fill: $color-rwl-green-100;

  .testimonials-slider {
    background-color: #fff;
    font-family: $font-family-rwl-base;
    font-size: $font-size-rwl-body;
    line-height: $line-height-rwl-body;
    position: relative;
    margin-bottom: $spacing-9;

    &.with-decoration-triangle::after {
      $size: 50px;
      // todo przenieś do mixina jako arrow top right
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      left: 100px + 30px;
      transform: translateX(-100%);
      top: -$size;

      border-style: solid;
      border-width: 0 $size $size 0;
      border-color: transparent transparent $color-rwl-white-100 transparent;
    }

    &__slide-content {
      padding: $spacing-2 $spacing-1;
      margin: 20px;
      font-style: italic;
    }

    &__slide-author {
      font-style: normal;
      text-align: right;

      span {
        display: block;
      }
    }

    blockquote {
      margin: 0;
      padding: 0;
    }

    &__button-prev {
      fill: $arrow-fill;
      left: 5px;

      &::after {
        content: none;
      }
    }

    &__button-next {
      fill: $arrow-fill;
      right: 5px;

      &::after {
        content: none;
      }
    }
  }

  @media (min-width: $breakpoint-sm-min) {
    .testimonials-slider {
      font-size: $font-size-rwl-headline-6;
      line-height: $line-height-rwl-headline-6;

      &__slide-content {
        padding: $spacing-7 $spacing-9;
        margin: 40px;
      }

      &__button-prev {
        left: 30px;
      }

      &__button-next {
        right: 30px;
      }
    }
  }

</style>
